import { Spinner } from "components/svg";

export const Icons = {
  spinner: Spinner,
};

